module.exports = __webpack_public_path__ + "img/20200613_093922.cba6b69a.jpg";